import React from 'react';
import { Link } from 'react-router-dom';
import DayraLogo from './ui/DayraLogo';

const columns = [
  {
    heading: 'Marketplace',
    links: [
      { label: 'Browse services', to: '/listings' },
      { label: 'Sign up', to: '/signup' },
    ],
  },
  {
    heading: 'Companies',
    links: [
      { label: 'Join as a company', to: '/signup/company' },
      { label: 'List a service', to: '/listings/create' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy policy', to: '/privacy' },
      { label: 'Terms of use', to: '/terms' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-ink-900 text-sand-300 border-t border-ink-700">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <DayraLogo variant="light" />
            <p className="text-sm text-sand-300/80 leading-relaxed mt-3 max-w-xs">
              UAE's marketplace for trusted cleaning services — find a company, book in minutes.
            </p>
          </div>

          {columns.map(col => (
            <div key={col.heading}>
              <h3 className="text-xs font-semibold text-white uppercase tracking-widest mb-4">
                {col.heading}
              </h3>
              <ul className="flex flex-col gap-3">
                {col.links.map(link => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-sand-300/80 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-ink-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-sand-300/60">
            © {new Date().getFullYear()} Dayra. All rights reserved.
          </p>
          <p className="text-xs text-sand-300/60">Made for the UAE</p>
        </div>
      </div>
    </footer>
  );
}
